<template>
  <el-dialog title="選擇發送方式" :visible.sync="internalVisible" width="700px" top="2vh" append-to-body center custom-class="share-custom-dialog" @open="handelOpen" v-loading="isLoading">
    <div class="info-card p-4">
      <div class="order-displayId mb-3">{{ `#${data.displayId}` }}</div>
      <div class="info-item mb-2">預約姓名：{{ data.fullName }} {{ data.gender | genderFilter }}</div>

      <div class="info-item mb-2">預約分店：{{ storeName || '' }}</div>

      <div class="info-item flex-item">
        <span class="label">預約項目：</span>
        <span class="content">{{ data.items }}</span>
      </div>
    </div>

    <div class="share-grid">
      <div class="share-item" @click="$emit('share', 'facebook', shortURL)">
        <div class="icon-box"><i class="fab fa-facebook-f"></i></div>
        <span class="label">Facebook</span>
      </div>
      <div class="share-item" @click="$emit('share', 'line', shortURL)">
        <div class="icon-box"><BaseIcon name="line" icon-style="fab"/></div>
        <span class="label">LINE</span>
      </div>
      <div class="share-item" @click="$emit('send-sms')">
        <div class="icon-box">
          <i v-if="loadingSms" class="el-icon-loading"></i>
          <i v-else class="fas fa-comment-dots"></i>
        </div>
        <span class="label">簡訊</span>
      </div>
      <div class="share-item" @click="$emit('copy', shortURL)">
        <div class="icon-box"><i class="fas fa-copy"></i></div>
        <span class="label">複製連結</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getMerchantProductInfo, getOrderShortUrl } from '@/src/apis'

export default {
  name: 'SharePaymentLinkPartial',
  props: {
    visible: { type: Boolean, default: false },
    data: {
      type: Object,
      default: () => ({
        displayId: '',
        fullName: '',
        gender: '',
        productId: '',
        items: '',
        uuid: '',
      }),
    },
    loadingSms: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: false,
      storeName: '',
      shortURL: '',
    }
  },
  computed: {
    internalVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  filters: {
    genderFilter(val) {
      const genderMap = { male: '先生', female: '小姐' }
      return genderMap[val] || val
    },
  },
  methods: {
    async handelOpen() {
      await this.fetchProduct(this.data.productId)
      await this.fetchShortURL(this.data.uuid)
    },
    async fetchProduct(id) {
      this.isLoading = true
      try {
        const res = await getMerchantProductInfo(id)
        this.storeName = res?.title || ''
      } catch (error) {
        console.error('API Error:', error)
      } finally {
        this.isLoading = false
      }
    },
    async fetchShortURL(uuid) {
      this.isLoading = true
      try {
        const res = await getOrderShortUrl(uuid)
        this.shortURL = res || ''
      } catch (error) {
        console.error('API Error:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$brand-orange: #ea6a2a;

.info-card {
  background-color: #f8f9fa;
  border-radius: 12px;
  text-align: left;
  padding: 25px 40px;
  margin: 0 20px;

  .order-displayId {
    color: $brand-orange;
    font-weight: bold;
    font-size: 1.25rem;
    letter-spacing: 0.5px;
  }

  .info-item {
    color: #444;
    font-size: 1.1rem;
    font-weight: 400;
    white-space: pre-line;

    // 這裡是你最讚的 flex 排版，維持原 UI 視覺但解決換行對齊
    &.flex-item {
      display: flex;
      align-items: flex-start;

      .label {
        flex-shrink: 0; // 防擠壓神器
      }

      .content {
        white-space: pre-line;
      }
    }
  }
}

.share-grid {
  display: flex;
  justify-content: space-around;
  padding: 40px 30px 20px;

  .share-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    flex: 1;

    .icon-box {
      width: 72px;
      height: 72px;
      background-color: $brand-orange;
      color: white;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
      margin-bottom: 12px;
      transition: all 0.2s ease;

      &:hover {
        background-color: lighten($brand-orange, 5%);
        transform: scale(1.05);
      }
    }

    .label {
      color: #333;
      font-size: 1.1rem;
      font-weight: 500;
      letter-spacing: 1px;
    }
  }
}

::v-deep .el-dialog__title {
  font-weight: 500;
  font-size: 22px;
}
</style>
